import { useState, type ReactNode } from 'react'
import { fbt } from 'fbtee'
import { ChevronRight } from 'lucide-react'
import { cn } from '../../lib/utils'

/** The group's past events, collapsed under a "Previous" heading until tapped. */
export function PreviousEventsDisclosure({ count, children }: { count: number; children: ReactNode }) {
  const [open, setOpen] = useState(false)
  return (
    <section className="space-y-1" data-testid="group-previous">
      <button
        type="button"
        className="flex h-9 w-full cursor-pointer items-center gap-1 text-sm md:text-base font-medium uppercase tracking-wider text-muted-foreground"
        aria-expanded={open}
        onClick={() => setOpen(o => !o)}
      >
        {fbt('Previous', 'Section heading for previous events linked to the group')}
        <span className="tabular-nums">({count})</span>
        <ChevronRight className={cn('size-4 transition-transform', open && 'rotate-90')} />
      </button>
      {open && <div className="flex flex-col gap-3">{children}</div>}
    </section>
  )
}
